/**
 * Defers loading of product-card hover (secondary) images until the shopper actually hovers or focuses a card.
 *
 * The hover image is only ever revealed on pointer-capable devices (see the `pointer: fine` CSS), so on touch devices
 * it is never promoted and therefore never downloaded at all. In snippets/product-card.liquid the secondary image is
 * rendered with `data-src` / `data-srcset` and no `src`, so the browser does not fetch it on initial page load.
 */
(function () {
  // Only devices that can hover ever reveal the secondary image, so only they should ever load it.
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) {
    return;
  }

  function promote(img) {
    if (!img.dataset || (!img.dataset.src && !img.dataset.srcset)) {
      return;
    }

    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
    }

    if (img.dataset.src) {
      img.src = img.dataset.src;
    }

    delete img.dataset.src;
    delete img.dataset.srcset;
  }

  function handle(event) {
    var figure = event.target.closest ? event.target.closest('.product-card__figure') : null;

    if (!figure) {
      return;
    }

    figure
      .querySelectorAll('.product-card__image--secondary[data-src], .product-card__image--secondary[data-srcset]')
      .forEach(promote);
  }

  // `pointerover` and `focusin` both bubble, so a single delegated listener on the document covers every card on the
  // page, including cards injected later by faceting / pagination (which re-render the product list via the section API).
  document.addEventListener('pointerover', handle, { passive: true });
  document.addEventListener('focusin', handle);
})();
